// Import Vue and other required dependencies
import { createApp } from "vue";
import App from "./App.vue"; // Import main Vue component

// Plugin
import FontAwesomePlugin from "./plugins/font-awesome.js";

// Custom Plugin
import VueToastNotificationPlugin from "../common/js/mixin/vue-toast-notification.js";
import ApiClientPlugin from "../common/plugins/api_client.js";

// Common Util
import DateTime from "../common/js/mixin/date-time.js";
import Loader from "../common/js/mixin/loader.js";
import Misc from "../common/js/mixin/misc.js";
import Utils from "../common/js/mixin/utils.js";

// Pay & Go app Util
import PngPayment from "../common/js/png_app/payment.js";

// Project Util


// API Service
import DefaultAPI from "./api_service/default.js";

// Style
import "./css/main.scss";

// Component
import Header from "./components/header/Header.vue";
import Footer from "./components/footer/Footer.vue";

const env = import.meta.env;
const app = createApp(App);

// Must be import before common util to prevent "Cannot convert undefined or null to object" error
app.mixin(DefaultAPI);

app.mixin(DateTime);
app.mixin(Loader);
app.mixin(Misc);
app.mixin(Utils);

app.mixin(PngPayment);

app.component("Header", Header);
// app.component("Footer", Footer);

app.use(FontAwesomePlugin);
app.use(VueToastNotificationPlugin);

app.use(ApiClientPlugin, {
    client_url: {
        default: env.VITE_API_URL,
        // user: "https://api.users.com",
    },
});

// Get constant value from .env
const device_tag = env.VITE_DEBUG_DEVICE_TAG;
const WEB_URL = env.VITE_WEB_URL;

app.provide("device_tag", device_tag);
app.provide("WEB_URL", WEB_URL);

app.mount("#app");